import Link from "next/link";

export default function Footer() {
  return (
    <footer className="bg-gray-100 border-t border-gray-200 pt-8 sm:pt-12 pb-6 sm:pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {/* Company Info */}
          <div className="col-span-1 sm:col-span-2 lg:col-span-1">
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-purple-600">
              TheEnterCountant.eu
            </h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              Connecting businesses with expert accounting mentors across
              Europe.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-gray-800 text-sm sm:text-base">
              Services
            </h4>
            <ul className="space-y-2 text-gray-600 text-sm sm:text-base">
              <li>
                <Link
                  href="/#services"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Financial Planning
                </Link>
              </li>
              <li>
                <Link
                  href="/#services"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Tax Optimization
                </Link>
              </li>
              <li>
                <Link
                  href="/#services"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Business Growth
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-gray-800 text-sm sm:text-base">
              Company
            </h4>
            <ul className="space-y-2 text-gray-600 text-sm sm:text-base">
              <li>
                <Link
                  href="/booking"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Our Experts
                </Link>
              </li>
              <li>
                <Link
                  href="/contact"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-gray-800 text-sm sm:text-base">
              Support
            </h4>
            <ul className="space-y-2 text-gray-600 text-sm sm:text-base">
              <li>
                <a
                  href="#"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Help Center
                </a>
              </li>
              <li>
                <Link
                  href="/privacy"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="hover:text-purple-600 transition-colors block py-1"
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-gray-500 text-xs sm:text-sm mb-2">
            &copy; 2025 TheEnterCountant.eu. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs">
            Developed by{" "}
            <a
              href="https://nlabs.be"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-purple-600 transition-colors font-medium"
            >
              NLABS BV
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
